import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import FAQSection from './components/FAQSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <TopicsSection />
        <CommentsSection />
        <AboutSection />
        <CarouselSection />
        <RankingSection />
        <IndexSection />
        <AppSection />
        <FeaturesSection />
        <ContactSection />
        <UpdatesSection />
        <FAQSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}